import MiSpinner from './MiSpinner.vue'

export default MiSpinner
